(function (angular) {
	'use strict';

	angular
		.module('eventsModule')
		.factory('mixpanelFactory', [
			'$window',
			mixpanelFunction
		]);

	function mixpanelFunction($window) {
		var factory = {
			track: track,
			register: register,
			getDistinctId: getDistinctId
		};

		return factory;

		function register(object) {
			if ($window.mixpanel) {
				$window.mixpanel.register(object);
			}
		}
		
		function track(eventName, object) {
			var properties = object || {};
			properties['Page URL'] = $window.location.pathname;
			properties['Sanitized Page URL'] = $window.location.pathname.replace(/[0-9]+/g, 'X');
			if ($window.mixpanel) {
				$window.mixpanel.track(eventName, properties);
			}
		}

		function getDistinctId() {
			if ($window.mixpanel && angular.isFunction($window.mixpanel.get_distinct_id)) {
				return $window.mixpanel.get_distinct_id();
			} else {
				return undefined;
			}
		}
	}
})(window.angular);